import { Row, usePrevTheme } from '@prev/ui-kit'
import React, { useContext, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { getSlugDaURL, navigateWithSearch } from '../../../utils/utils'
import { LoginContext } from '../contexts/LoginContext'
import SignIn from '../components/forms/SignIn'
import SlugSignIn from '../components/forms/SlugSignIn'
import LoginHero from '../components/LoginHero'

const Login = (): JSX.Element | null => {
  const { theme } = usePrevTheme()
  const token = localStorage.getItem('access_token_prev')
  const slug = getSlugDaURL()

  useEffect(() => {
    localStorage.removeItem('access_token_prev')
    localStorage.removeItem('refresh_token_prev')
  }, [])

  return (
    <Row
      style={{
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        overflow: 'hidden',
        padding: 0,
        margin: 0,
        backgroundColor: theme.color.surface.container.default,
      }}
    >
      <Row style={{ width: '1280px' }}>
        {slug && !token && <SignIn />}
        {!slug && <SlugSignIn />}
        <LoginHero />
      </Row>
    </Row>
  )
}

export default Login
